export const TextChapters = {
    tanakh: {
        Genesis: 50,
        Exodus: 40,
        Leviticus: 27,
        Numbers: 36,
        Deuteronomy: 34,
        Joshua: 24,
        Judges: 21,
        I_Samuel: 31,
        II_Samuel: 24,
        I_Kings: 22,
        II_Kings: 25,
        Isaiah: 66,
        Jeremiah: 52,
        Ezekiel: 48,
        Hosea: 14,
        Joel: 4,
        Amos: 9,
        Obadiah: 1,
        Jonah: 4,
        Micah: 7,
        Nahum: 3,
        Habakkuk: 3,
        Zephaniah: 3,
        Haggai: 2,
        Zechariah: 14,
        Malachi: 3,
        Psalms: 150,
        Proverbs: 31,
        Job: 42,
        Song_of_Songs: 8,
        Ruth: 4,
        Lamentations: 5,
        Ecclesiastes: 12,
        Esther: 10,
        Daniel: 12,
        Ezra: 10,
        Nehemiah: 13,
        I_Chronicles: 29,
        II_Chronicles: 36
    },
    parashas: {

        Bereishit: {
            text: "Genesis",
            startChapter: 1,
            startVerse: 1,
            endChapter: 6,
            endVerse: 8
        },
        Noach: {
            text: "Genesis",
            startChapter: 6,
            startVerse: 9,
            endChapter: 11,
            endVerse: 32
        },
        Lech_Lecha: {
            text: "Genesis",
            startChapter: 12,
            startVerse: 1,
            endChapter: 17,
            endVerse: 27
        },
        Vayera: {
            text: "Genesis",
            startChapter: 18,
            startVerse: 1,
            endChapter: 22,
            endVerse: 24
        },
        Chayei_Sarah: {
            text: "Genesis",
            startChapter: 23,
            startVerse: 1,
            endChapter: 25,
            endVerse: 18
        },
        Toldot: {
            text: "Genesis",
            startChapter: 25,
            startVerse: 19,
            endChapter: 28,
            endVerse: 9
        },
        Vayetze: {
            text: "Genesis",
            startChapter: 28,
            startVerse: 10,
            endChapter: 32,
            endVerse: 3
        },
        Vayishlach: {
            text: "Genesis",
            startChapter: 32,
            startVerse: 4,
            endChapter: 36,
            endVerse: 43
        },
        Vayeshev: {
            text: "Genesis",
            startChapter: 37,
            startVerse: 1,
            endChapter: 40,
            endVerse: 23
        },
        Miketz: {
            text: "Genesis",
            startChapter: 41,
            startVerse: 1,
            endChapter: 44,
            endVerse: 17
        },
        Vayigash: {
            text: "Genesis",
            startChapter: 44,
            startVerse: 18,
            endChapter: 47,
            endVerse: 27
        },
        Vayechi: {
            text: "Genesis",
            startChapter: 47,
            startVerse: 28,
            endChapter: 50,
            endVerse: 26
        },
        Shemot: {
            text: "Exodus",
            startChapter: 1,
            startVerse: 1,
            endChapter: 6,
            endVerse: 1
        },
        Vaera: {
            text: "Exodus",
            startChapter: 6,
            startVerse: 2,
            endChapter: 9,
            endVerse: 35
        },
        Bo: {
            text: "Exodus",
            startChapter: 10,
            startVerse: 1,
            endChapter: 13,
            endVerse: 16
        },
        Beshalach: {
            text: "Exodus",
            startChapter: 13,
            startVerse: 17,
            endChapter: 17,
            endVerse: 16
        },
        Yitro: {
            text: "Exodus",
            startChapter: 18,
            startVerse: 1,
            endChapter: 20,
            endVerse: 23
        },
        Mishpatim: {
            text: "Exodus",
            startChapter: 21,
            startVerse: 1,
            endChapter: 24,
            endVerse: 18
        },
        Terumah: {
            text: "Exodus",
            startChapter: 25,
            startVerse: 1,
            endChapter: 27,
            endVerse: 19
        },
        Tetzaveh: {
            text: "Exodus",
            startChapter: 27,
            startVerse: 20,
            endChapter: 30,
            endVerse: 10
        },
        Ki_Tisa: {
            text: "Exodus",
            startChapter: 30,
            startVerse: 11,
            endChapter: 34,
            endVerse: 35
        },
        Vayakhel: {
            text: "Exodus",
            startChapter: 35,
            startVerse: 1,
            endChapter: 38,
            endVerse: 20
        },
        Pekudei: {
            text: "Exodus",
            startChapter: 38,
            startVerse: 21,
            endChapter: 40,
            endVerse: 38
        },
        Vayikra: {
            text: "Leviticus",
            startChapter: 1,
            startVerse: 1,
            endChapter: 5,
            endVerse: 26
        },
        Tzav: {
            text: "Leviticus",
            startChapter: 6,
            startVerse: 1,
            endChapter: 8,
            endVerse: 36
        },
        Shemini: {
            text: "Leviticus",
            startChapter: 9,
            startVerse: 1,
            endChapter: 11,
            endVerse: 47
        },
        Tazria: {
            text: "Leviticus",
            startChapter: 12,
            startVerse: 1,
            endChapter: 13,
            endVerse: 59
        },
        Metzora: {
            text: "Leviticus",
            startChapter: 14,
            startVerse: 1,
            endChapter: 15,
            endVerse: 33
        },
        Acharei_Mot: {
            text: "Leviticus",
            startChapter: 16,
            startVerse: 1,
            endChapter: 18,
            endVerse: 30
        },
        Kedoshim: {
            text: "Leviticusa",
            startChapter: 19,
            startVerse: 1,
            endChapter: 20,
            endVerse: 27
        },
        Emor: {
            text: "Leviticus",
            startChapter: 21,
            startVerse: 1,
            endChapter: 24,
            endVerse: 23
        },
        Behar: {
            text: "Leviticus",
            startChapter: 25,
            startVerse: 1,
            endChapter: 26,
            endVerse: 2
        },
        Bechukotai: {
            text: "Leviticus",
            startChapter: 26,
            startVerse: 3,
            endChapter: 27,
            endVerse: 34
        },
        Bamidbar: {
            text: "Numbers",
            startChapter: 1,
            startVerse: 1,
            endChapter: 4,
            endVerse: 20
        },
        Naso: {
            text: "Numbers",
            startChapter: 4,
            startVerse: 21,
            endChapter: 7,
            endVerse: 89
        },
        Behaalotecha: {
            text: "Numbers",
            startChapter: 8,
            startVerse: 1,
            endChapter: 12,
            endVerse: 16
        },
        Shelach: {
            text: "Numbers",
            startChapter: 13,
            startVerse: 1,
            endChapter: 15,
            endVerse: 41
        },
        Korach: {
            text: "Numbers",
            startChapter: 16,
            startVerse: 1,
            endChapter: 18,
            endVerse: 32
        },
        Chukat: {
            text: "Numbers",
            startChapter: 19,
            startVerse: 1,
            endChapter: 22,
            endVerse: 1
        },
        Balak: {
            text: "Numbers",
            startChapter: 22,
            startVerse: 2,
            endChapter: 25,
            endVerse: 9
        },
        Pinchas: {
            text: "Numbers",
            startChapter: 25,
            startVerse: 10,
            endChapter: 30,
            endVerse: 1
        },
        Matot: {
            text: "Numbers",
            startChapter: 30,
            startVerse: 2,
            endChapter: 32,
            endVerse: 42
        },
        Massei: {
            text: "Numbers",
            startChapter: 33,
            startVerse: 1,
            endChapter: 36,
            endVerse: 13
        },
        Devarim: {
            text: "Deuteronomy",
            startChapter: 1,
            startVerse: 1,
            endChapter: 3,
            endVerse: 22
        },
        Vaetchanan: {
            text: "Deuteronomy",
            startChapter: 3,
            startVerse: 23,
            endChapter: 7,
            endVerse: 11
        },
        Eikev : {
            text: "Deuteronomy",
            startChapter: 3,
            startVerse: 23,
            endChapter: 7,
            endVerse: 11
        },
        Reeh: {
            text: "Deuteronomy",
            startChapter: 11,
            startVerse: 26,
            endChapter: 16,
            endVerse: 17
        },
        Shoftim: {
            text: "Deuteronomy",
            startChapter: 16,
            startVerse: 18,
            endChapter: 21,
            endVerse: 9
        },
        Ki_Teitzei: {
            text: "Deuteronomy",
            startChapter: 21,
            startVerse: 10,
            endChapter: 25,
            endVerse: 19
        },
        Ki_Tavo: {
            text: "Deuteronomy",
            startChapter: 26,
            startVerse: 1,
            endChapter: 29,
            endVerse: 8
        },
        Nitzavim: {
            text: "Deuteronomy",
            startChapter: 29,
            startVerse: 9,
            endChapter: 30,
            endVerse: 20
        },
        Vayelech: {
            text: "Deuteronomy",
            startChapter: 31,
            startVerse: 1,
            endChapter: 31,
            endVerse: 30
        },
        Haazinu: {
            text: "Deuteronomy",
            startChapter: 32,
            startVerse: 1,
            endChapter: 32,
            endVerse: 52
        },
        VZot_HaBerachah: {
            text: "Deuteronomy",
            startChapter: 33,
            startVerse: 1,
            endChapter: 34,
            endVerse: 12
        },
    },
    mishnah: {
        Mishnah_Berakhot: 9,
        Mishnah_Peah: 8,
        Mishnah_Demai: 7,
        Mishnah_Kilayim: 9,
        Mishnah_Sheviit: 10,
        Mishnah_Terumot: 11,
        Mishnah_Maasrot: 5,
        Mishnah_Maaser_Sheni: 5,
        Mishnah_Challah: 4,
        Mishnah_Orlah: 3,
        Mishnah_Bikkurim: 4,
        Mishnah_Shabbat: 24,
        Mishnah_Eruvin: 10,
        Mishnah_Pesachim: 10,
        Mishnah_Shekalim: 8,
        Mishnah_Yoma: 8,
        Mishnah_Sukkah: 5,
        Mishnah_Beitzah: 5,
        Mishnah_Rosh_Hashanah: 4,
        Mishnah_Taanit: 4,
        Mishnah_Megillah: 4,
        Mishnah_Moed_Katan: 3,
        Mishnah_Chagigah: 3,
        Mishnah_Yevamot: 16,
        Mishnah_Ketubot: 13,
        Mishnah_Nedarim: 11,
        Mishnah_Nazir: 9,
        Mishnah_Sotah: 9,
        Mishnah_Gittin: 9,
        Mishnah_Kiddushin: 4,
        Mishnah_Bava_Kamma: 10,
        Mishnah_Bava_Metzia: 10,
        Mishnah_Bava_Batra: 10,
        Mishnah_Sanhedrin: 11,
        Mishnah_Makkot: 3,
        Mishnah_Shevuot: 8,
        Mishnah_Eduyot: 8,
        Mishnah_Avodah_Zarah: 5,
        Mishnah_Avot: 5,
        Mishnah_Horayot: 3,
        Mishnah_Zevachim: 14,
        Mishnah_Menachot: 13,
        Mishnah_Chullin: 12,
        Mishnah_Bekhorot: 9,
        Mishnah_Arakhin: 9,
        Mishnah_Temurah: 7,
        Mishnah_Keritot: 6,
        Mishnah_Meilah: 6,
        Mishnah_Tamid: 7,
        Mishnah_Middot: 5,
        Mishnah_Kinnim: 3,
        Mishnah_Kelim: 30,
        Mishnah_Oholot: 18,
        Mishnah_Negaim: 14,
        Mishnah_Parah: 12,
        Mishnah_Tahorot: 10,
        Mishnah_Mikvaot: 10,
        Mishnah_Niddah: 10,
        Mishnah_Makhshirin: 6,
        Mishnah_Zavim: 5,
        Mishnah_Tevul_Yom: 4,
        Mishnah_Yadayim: 4,
        Mishnah_Oktzin: 3
    },
    talmud: {
        Berakhot: 64,
        Shabbat: 157,
        Eruvin: 105,
        Pesachim: 121,
        Rosh_Hashanah: 35,
        Yoma: 88,
        Sukkah: 56,
        Beitzah: 40,
        Taanit: 31,
        Megillah: 32,
        Moed_Katan: 29,
        Chagigah: 27,
        Yevamot: 122,
        Ketubot: 112,
        Nedarim: 91,
        Nazir: 66,
        Sotah: 49,
        Gittin: 90,
        Kiddushin: 82,
        Bava_Kamma: 119,
        Bava_Metzia: 119,
        Bava_Batra: 176,
        Sanhedrin: 113,
        Makkot: 24,
        Shevuot: 49,
        Avodah_Zarah: 76,
        Horayot: 14,
        Zevachim: 120,
        Menachot: 110,
        Chullin: 142,
        Bekhorot: 61,
        Arakhin: 34,
        Temurah: 34,
        Keritot: 28,
        Meilah: 22,
        Tamid: 8,
        Niddah: 73
    }
}
